import { Auth } from 'aws-amplify';
import { hallpassApi, killshotApi } from '../api';

/**
 * Get current user's session
 * @returns {promise} A promise resolves to session object if success
 */
export const getUserInfo = async () => {
  const session = await Auth.currentSession();
  const { payload } = session.idToken;
  const userId = payload['cognito:username'];
  const organizationId = payload['custom:organization_id'];
  const teamId = payload['custom:team_id'];

  const userInfo = {
    username: userId,
    token: session.idToken.jwtToken,
    isAuthenticated: true,
    teamId,
    organizationId,
    email: payload.email,
  };
  return userInfo;
};

export const getUserOrganization = async organizationId => {
  try {
    const response = await hallpassApi.get(`/v0/organizations/${organizationId}`);
    return response;
  } catch (e) {
    throw e;
  }
};

export const fetchMenuLinks = async () => {
  const data = await killshotApi.get(`v1/menu_links`);
  return data && data.response;
};
